module.exports = __webpack_public_path__ + "img/cb70b76.png";